"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSignedUrl = getSignedUrl;
exports.uploadFileToS3 = uploadFileToS3;
exports.uploadImage = uploadImage;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function getSignedUrl(_x, _x2) {
  return _getSignedUrl.apply(this, arguments);
}

function _getSignedUrl() {
  _getSignedUrl = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(fileName, fileType) {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileType = encodeURIComponent(fileType);
            _context.next = 3;
            return _axios.default.get("/attachment/signedUrl?filename=".concat(fileName, "&content_type=").concat(fileType));

          case 3:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getSignedUrl.apply(this, arguments);
}

function uploadImage(_x3) {
  return _uploadImage.apply(this, arguments);
}

function _uploadImage() {
  _uploadImage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(formData) {
    var _yield$axios$post, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post('/attachment/new', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 2:
            _yield$axios$post = _context2.sent;
            data = _yield$axios$post.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _uploadImage.apply(this, arguments);
}

function uploadFileToS3(_x4, _x5, _x6, _x7) {
  return _uploadFileToS.apply(this, arguments);
}

function _uploadFileToS() {
  _uploadFileToS = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(url, file, fileType, tags) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.put(url, file, {
              headers: {
                'content-type': fileType + '; charset=utf-8',
                'x-amz-tagging': tags,
                'X-Requested-With': undefined,
                'content-disposition': 'attachment'
              }
            });

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _uploadFileToS.apply(this, arguments);
}